export default "__VITE_ASSET__CX08SexG__"